import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription, first } from 'rxjs';
import { DataService } from '../../services/data.service';
import { SiteService } from '../../services/site.service';
import { getQueryParamFromAncestorRoute } from '../../utilities/route.utilities';
import { MasonryItemModel } from '../masonry/masonry.component';
import { IssuesBilledInSlaGridItemComponent } from './grid-item/billing/issues-billed-in-sla-grid-item.component';
import { IssuesBillingAgedDebtGridItemComponent } from './grid-item/billing/issues-billing-aged-debt-credit-grid-item.component';
import { IssuesLatestBillEstimatedGridItemComponent } from './grid-item/billing/issues-latest-bill-estimated-grid-item.component';

@Component({
    selector: 'issues-billing',
    templateUrl: './issues-billing.component.html'
})

export class IssuesBillingComponent implements OnInit, OnDestroy {

    masonryItems: MasonryItemModel[] = [];
    subscriptions: Subscription[] = [];
    clientId: number;
    selectedSiteId: number = 0;
    userSiteId: number = 0;
    sites: any[] = [];

    constructor(private dataService: DataService,
        private route: ActivatedRoute,
        private router: Router,
        private siteService: SiteService) { }

    ngOnInit() {
        this.masonryItems = [
            {
                component: IssuesBilledInSlaGridItemComponent,
                isExpandable: true
            },
            {
                component: IssuesBillingAgedDebtGridItemComponent,
                isExpandable: true
            },
            {
                component: IssuesLatestBillEstimatedGridItemComponent,
                isExpandable: true
            }
        ];

        // update isExpandable per item, if data is resolved
        this.dataService.issuesBilledInSlaGridItemComponentResolved.pipe(first()).subscribe(
            result => this.masonryItems.find(x => x.component == IssuesBilledInSlaGridItemComponent).isExpandable = result
        )
        this.dataService.issuesBillingAgedDebtGridItemComponentResolved.pipe(first()).subscribe(
            result => this.masonryItems.find(x => x.component == IssuesBillingAgedDebtGridItemComponent).isExpandable = result
        )
        this.dataService.issuesBillingLatestBillEstimatedGridItemComponentResolved.pipe(first()).subscribe(
            result => this.masonryItems.find(x => x.component == IssuesLatestBillEstimatedGridItemComponent).isExpandable = result
        )

        this.userSiteId = parseInt(getQueryParamFromAncestorRoute(this.route, 'siteId'));

        this.subscriptions.push(this.route
            .parent!
            .parent!
            .params
            .subscribe(params => {
                this.clientId = +params['clientId'];
                this.search();
            }));

        if (Number.isNaN(this.userSiteId) || this.userSiteId === undefined) { this.userSiteId = 0; }

        this.selectedSiteId = this.userSiteId;
    }

    ngOnDestroy() {
        this.subscriptions.forEach(s => s.unsubscribe());
    }

    search() {
        this.siteService.all(this.clientId).then((result) => {
            this.sites = result;
            this.selectedSiteId
        });
    }

    updateSite() {
        let queryParams: any = JSON.parse(JSON.stringify(this.route.snapshot.queryParams)) as any;
        if (this.selectedSiteId != undefined && this.selectedSiteId != null) {
            queryParams.siteId = +this.selectedSiteId;
        }
        this.router.navigate(['/portal/' + this.clientId.toString() + '/issues/billing'], {
            queryParams: queryParams,
            replaceUrl: true
        }).then(result => {
            this.ngOnDestroy();
            this.ngOnInit();
        });
    }
}
